var phoneNumberRegex = /\d*/;
export var isNotAllSameDigit = function (value) {
    return !/^(\d)\1+$/.test(value);
};
// Is not a sequence of 7 digits.
export var isNotSequence = function (value) {
    return !/(0123456|1234567|2345678|3456789)/.test(value);
};
export default {
    phoneNumberRegex: phoneNumberRegex,
    isNotAllSameDigit: isNotAllSameDigit,
    isNotSequence: isNotSequence,
};
